export default function WarningModal () {
  return <div></div>
}
